import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ILoginUserInfo } from '../dto/LoginUserInfo';
import { routingControlModule } from './RoutingControl';
import { kanriManagementModule } from '../../Kanri/store/modules/KanriManagement';
import { uketsukeManagementModule } from '../../Uketsuke/store/modules/UketsukeManger';
import { Constants } from '@/CommonUtils/fixed/Constants';

@Module({ dynamic: true, store, name: 'operationSupervising', namespaced: true })
class OperationSupervising extends VuexModule {
    // state
    /**
     * @State
     * 画面操作モード
     */
    mode = ScreenMode.READ;

    /**
     * @state
     * ユーザ情報
     */
    userInfo: ILoginUserInfo = {
        username: '',
        authorities: [],
        isOrderUser: false,
        szkNm: '',
        isFirstLogin: false,
        // 2023.11.16 [2023L-04] add start
        isDetoxAp: false,
        // 2023.11.16 [2023L-04] add end
    };

    /**
     * @state
     * テナントID
     */
    tenantId: string = '';

    // getter
    /**
     * @Getter
     * 画面操作モードの取得
     */
    get GET_MODE() {
        return this.mode;
    }
    /**
     * @Getter
     * ユーザ情報の取得
     */
    get GET_USER_INFO() {
        return this.userInfo;
    }
    /**
     * @Getter
     * テナントIDの取得
     */
    get GET_TENANT_ID() {
        return this.tenantId;
    }

    /**
     * @Getter
     * 更新モードの時trueを返すチェッカー
     */
    get CHECK_MODE_UPDATE(): boolean {
        if (this.mode === ScreenMode.UPDATE) {
            return true;
        }
        return false;
    }

    /**
     * @Getter
     * 参照モードかどうかを返す
     */
    get IS_MODE_READ(): boolean {
        if (this.mode === ScreenMode.READ) {
            return true;
        }
        return false;
    }
    /**
     * @Getter
     * 発注者ユーザかどうかを返す
     */
    get IS_ORDER_USER(): boolean {
        return this.GET_USER_INFO.isOrderUser;
    }
    /**
     * @Getter
     * 初回ログインユーザかどうかを返す
     */
    get IS_FIRST_LOGIN(): boolean {
        return this.GET_USER_INFO.isFirstLogin;
    }
    // 2023.11.16 [2023L-04] add start
    /**
     * @Getter
     * 無害化apかどうかを返す
     */
    get IS_DETOX_AP(): boolean {
        return this.GET_USER_INFO.isDetoxAp;
    }
    // 2023.11.16 [2023L-04] add end
    /**
     * @Getter
     * ユーザ権限の一覧を取得
     */
    get GET_AUTHORITIES() {
        return this.userInfo.authorities;
    }

    /**
     * @Action
     * APIから取得したモードのセット
     */
    @Action({})
    public setMode(param: string) {
        this.SET_MODE(param);
    }

    /**
     * @Action
     * ユーザ情報のセット
     */
    @Action({})
    public setUserInfo(param: ILoginUserInfo) {
        this.SET_USER_INFO(param);
    }
    /**
     * @Action
     * 初回ログインフラグのセット
     */
    @Action({})
    public setFirstLogin(param: boolean) {
        this.SET_FIRST_LOGIN(param);
    }
    // 2023.11.16 [2023L-04] add start
    /**
     * @Action
     * 無害化apのセット
     */
    @Action({})
    public setDetoxAp(param: boolean) {
        this.SET_DETOX_AP(param);
    }
    // 2023.11.16 [2023L-04] add end
    /**
     * @Action
     * テナントIDのセット
     */
    @Action({})
    public setTenantId(param: string) {
        this.SET_TENANT_ID(param);
    }

    /**
     * @Action
     * すべてのストアモジュールを初期化する
     */
    @Action({})
    public allModuleReset() {
        routingControlModule.moduleReset();
        kanriManagementModule.moduleReset();
        uketsukeManagementModule.moduleReset();
    }

    /**
     * @Mutation
     * APIから取得したモードのセット
     * @param param モード
     */
    @Mutation
    private SET_MODE(param: string) {
        this.mode = param;
    }

    /**
     * @Mutation
     * ユーザ情報のセット
     * @param param ユーザ情報
     */
    @Mutation
    private SET_USER_INFO(param: ILoginUserInfo) {
        this.userInfo = param;
    }
    /**
     * @Mutation
     * 初回ログインフラグのセット
     * @param param 初回ログインフラグ
     */
    @Mutation
    private SET_FIRST_LOGIN(param: boolean) {
        this.userInfo.isFirstLogin = param;
    }
    // 2023.11.16 [2023L-04] add start
    /**
     * @Mutation
     * 無害化apのセット
     * @param param detoxAp
     */
    @Mutation
    private SET_DETOX_AP(param: boolean) {
        this.userInfo.isDetoxAp = param;
    }
    // 2023.11.16 [2023L-04] add end
    /**
     * @Mutation
     * テナントIDのセット
     * @param param テナントID
     */
    @Mutation
    private SET_TENANT_ID(param: string) {
        this.tenantId = param;
    }
}

/**
 * 操作管理モジュール（SupervisingModule）
 * このモジュール内のstateはログアウト及びその他リセット実行時でも初期化しません。
 */
export const supervisingModule = getModule(OperationSupervising);
